import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import pageTitle from "../../utils/pageTitle";
import Axios from "../../utils/axios";
import SubmitButton from "../../components/button/SubmitButton";

import {
    AUTH_CHANGE_PASSWORD,
    REGEX_PASSWORD
} from "../../config";

import { showErrorAlert, showSuccessAlert } from "../../store/actions/alerts";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

export default function ChangePassword() {
    pageTitle("Change Password");
    const dispatch = useDispatch();
    const classes = useStyles();

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <Typography component="h2" variant="h5">
                    Change Password
                </Typography>
                <Formik
                    initialValues={{ password: "", newPassword: "", confirmPassword: "" }}
                    onSubmit={(values, { setSubmitting, setFieldValue }) => {
                        setSubmitting(true);
                        const axiosInstance = new Axios();

                        axiosInstance
                            .request({
                                url: AUTH_CHANGE_PASSWORD.url,
                                method: AUTH_CHANGE_PASSWORD.method,
                                data: values
                            })
                            .then(async response => {
                                dispatch(showSuccessAlert("Password Updated!"));
                                setFieldValue("password", "");
                                setFieldValue("newPassword", "");
                                setFieldValue("confirmPassword", "");
                                setSubmitting(false);
                            })
                            .catch(error => {
                                dispatch(
                                    showErrorAlert(
                                        !!error.response
                                            ? `${error.response.status}! - ${error.response.data.errorMessage}`
                                            : error.message
                                    )
                                );
                                setFieldValue("password", "");
                                setFieldValue("newPassword", "");
                                setFieldValue("confirmPassword", "");
                                setSubmitting(false);
                            });
                    }}
                    validationSchema={Yup.object().shape({
                        password: Yup.string().required("Current Password Required!"),
                        newPassword: Yup.string().required("New Password Required!")
                            .matches(REGEX_PASSWORD,
                                "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                            ),
                        confirmPassword: Yup.string().required("Confirm Password Required!")
                            .oneOf([Yup.ref('newPassword'), null], "Password Doesn't Match!")
                    })}
                >
                    {props => {
                        const {
                            values,
                            touched,
                            errors,
                            isSubmitting,
                            handleChange,
                            handleBlur,
                            handleSubmit
                        } = props;
                        return (
                            <form className={classes.form} onSubmit={handleSubmit}>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    id="password"
                                    label="Current Password"
                                    type="password"
                                    name="password"
                                    autoComplete="current-password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={
                                        touched.password && errors.password && errors.password
                                    }
                                    error={!!touched.password && !!errors.password}
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    name="newPassword"
                                    label="New Password"
                                    type="password"
                                    id="newPassword"
                                    value={values.newPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={
                                        touched.newPassword && errors.newPassword && errors.newPassword
                                    }
                                    error={!!touched.newPassword && !!errors.newPassword}
                                    disabled={isSubmitting}
                                />
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    name="confirmPassword"
                                    label="Confirm Password"
                                    type="password"
                                    id="confirmPassword"
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={
                                        touched.confirmPassword && errors.confirmPassword && errors.confirmPassword
                                    }
                                    error={!!touched.confirmPassword && !!errors.confirmPassword}
                                    disabled={isSubmitting}
                                />
                                <SubmitButton
                                    className={classes.submit}
                                    disabled={isSubmitting}
                                    isSubmitting={isSubmitting}
                                    autoFocus
                                    fullWidth
                                >
                                    Update Password
                                </SubmitButton>
                            </form>
                        );
                    }}
                </Formik>
            </div>
        </Container>
    )
}
